var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconButton',_vm._g(_vm._b({attrs:{"icon":"trash","title":_vm.$t('actions.delete'),"icon-classes":{
    'text-danger': !_vm.disabled,
  },"disabled":_vm.disabled}},'IconButton',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }